import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { environment } from '../../../environments/environment';
import { ProtocolAndBaseUrlUtil } from '../utility-classes/protocol-and-base-url.util';

@Injectable({
    providedIn: 'root'
})
export class EmailService {

    constructor(private domSanitizer: DomSanitizer, private http: HttpClient) { }

    public composeAllEmailUrl(emails: string[], formInstanceName: string, formInstanceLink: string): string {
        let emailsString: string = "";

        emails.forEach(email => {
            //Do NOT use the backtick interpolation to create this string, it will cause issues
            emailsString += email + ";";
        });

        let mailtoProp = "mailto:" + emailsString + "?";

        let subjectProp = "subject=";
        let bodyProp = "body=";
        let newLine = "%0D%0A";
        let footer = newLine + newLine + "This message was automatically generated by OMB Collect"
        let subject = formInstanceName + " link from OMB Collect";

        let body = "Greetings All," + newLine + newLine +
            "Please click the following link to access the form instance " + formInstanceName + ":" + newLine + newLine +
            formInstanceLink;

        const url = `${mailtoProp}${subjectProp}${subject}&${bodyProp}${body}${footer}`;
        return url;
    }

    public composeCustomEmailUrl(emailAddresses: string[], subjectText: string, bodyText: string): string {
        let emailAddressesString: string = "";

        emailAddresses.forEach(email => {
            //Do NOT use the backtick interpolation to create this string, it will cause issues
            emailAddressesString += email + ";";
        });

        let mailtoProp = "mailto:" + emailAddressesString + "?";

        let isBodyHtmlProp = "message.IsBodyHtml=true;";
        let subjectProp = "subject=";
        let bodyProp = "body=";
        let newLine = "%0D%0A";
        let footer = newLine + newLine + "This message was automatically generated by OMB Collect"

        //const url = `${mailtoProp}${subjectProp}${subjectText}&${bodyProp}${bodyText}`;
        const url = `${mailtoProp}${subjectProp}${subjectText}`; // Removed the body text as the user will now paste in this content.
        return url;
    }

    public SendErrorMail(msg: any) {
        let url = environment.apiUrl + "/api/Error/SendErrorMail";
        let message = { subject: msg.subject, body: msg.body, to: msg.to, CC: msg.cc };
        return this.http.post(url, message).toPromise();
    }

    public SendContactsMail(formInstanceId: any) {
        /*
        let baseurl = window.location.origin;
        let protocol = "https:";
        if (baseurl.indexOf("//") > 0) {
            protocol = baseurl.split("//")[0];
            baseurl = baseurl.split("//")[1];
        }
        */
        const protocolAndBaseUrl = ProtocolAndBaseUrlUtil.getProtocolAndBaseUrl();

        //let url = environment.apiUrl + `/api/Notification/SendContactsMail/${formInstanceId}/${protocol}/${baseurl}`;
        let url = environment.apiUrl + `/api/Notification/SendContactsMail/${formInstanceId}/${protocolAndBaseUrl.protocol}/${protocolAndBaseUrl.baseurl}`;
        return this.http.post(url, formInstanceId).toPromise();
    }
}
